export const en = {
  //home page
  LoadMoreProduct: 'More Products',
  btn2: 'Read More Reviews',
  btn4: 'More About Us',
  Result: `Smart Software `,
  Digital: `Built for Your Growth`,
  Solution: 'Solutions ',
  provide:
    'We turn business needs into reliable software: custom products, web platforms and mobile apps, delivered by an experienced team.',
  ourServices: 'Our services',
  TopProducts: 'Top Products',
  CustomerFeedback: 'Customer Feedback',
  textAboutUs: `
        Noova company with registration number
        16154778 started its work  in 2018. The founders of this company with more than ten years of experience in the field of programming and startup environment of the country,
        using their own experience and that of others,
        started to establish They participated.
        `,
  textAboutUsIP: `
        Noova company with registration number
        16154778 started its work  in 2018. The founders of this company with more than ten years of experience in the field of programming and startup environment of the country,
        using their own experience and that of others,
        started to establish They participated.
        `,
  OurProcess: 'Our Process',
  OurTrustedPartner: 'Our Trusted Partners',
  Explore: 'Explore your business ideas with our modern strategies',
  team: 'Our team is ready to help you achieve your business goals with creative and modern digital marketing strategies',
  //certification page
  text1: 'Certification',
  blog: 'Blog',
  loadMoreBlog: 'Load More Blogs',

  Home: 'Home',
  Products: 'Products',
  Projects: 'Projects',
  Blogs: 'Blogs',
  AboutUs: 'About Us',
  ContactUs: 'Contact Us',
  ChangeLang: 'Change Language to',
  SwitchMode: 'Switch to',
  mode1: 'Dark mode',
  mode2: 'Light mode',
  footerText: `
       Noova company with registry number 16154778 is a forward-thinking technology company specializing in web and mobile software development. We focus on designing and building high-quality iOS and Android applications, along with cutting-edge websites tailored to meet the demands of today's fast-evolving digital landscape. `,
  footerTextIp: `
       Noova company with registry number 16154778 is a forward-thinking technology company specializing in web and mobile software development. We focus on designing and building high-quality iOS and Android applications, along with cutting-edge websites tailored to meet the demands of today's fast-evolving digital landscape. `,

  QuickLinks: 'Quick links',
  Support: 'Support',
  Address: 'Address',
  Certification: 'Certification',
  allJob: 'Job opportunities',
  //about us page
  aboutText1: 'Noova company',
  aboutText2:
    'At Noova company, we believe in the power of digital marketing and help you to take your brand to the top by using new strategies. Since our establishment in 2019, our goal has been to provide innovative and effective solutions in the digital world. With a team of experts and successful experiences in various fields, we help you stand out online.',
  aboutText3: 'Our Mission',
  aboutblog: `
        Our mission is to promote brands and businesses through modern and
        creative strategies.We help you achieve your business goals using
        technology and digital innovations.
        `,
  aboutText5: 'company vision',
  aboutText6:
    "Currently, the company's plan is on the development of external products (applications and websites) and focusing on the fields of artificial intelligence and  conducting internal automation projects.",
  aboutText7: 'Awards and Honor',
  aboutText8: 'The final candidate for the best app in the Iran App and Mobile Festival in 2018 ',
  aboutText9:
    'The final candidate for the best project in the festival of the province of Up country in 1400',
  //detailBlog
  RelatedPost: 'Related posts',
  ReadMore: `Read More`,
  //job
  JobOpportunities: 'Job opportunities',
  closed: 'closed',
  //product
  ViewProduct: 'View Product',
  ViewProject: 'View Project',
  gallery: 'Gallery',
  Purpose: 'Purpose',
  TopFeatures: 'Top Features',
  TechnicalDetails: 'Technical Details',
  OtherFeatures: 'Other Features',
  Product: 'product',
  downloadApplication: 'Download Application',

  //jobDes
  JobDescription: 'Job Description',
  palaseHolderName: 'Enter your first name',
  palaseHolderFamily: 'Enter your last name',
  palaseHolderEmail: 'Enter your email address',
  palaseHolderPhone: 'Enter your phone number',
  labelName: 'First name',
  labelLastName: 'Last name',
  labelEmail: 'Email',
  labelNumber: 'Your number',
  CV: 'CV',
  Upload: 'Upload File',
  Max: 'Max file size: 30 MB',
  send: 'Send',
  LoadMoreJobs: 'Load More Jobs',

  //contact page
  Message: 'Your Message',
  Message2: 'Your Message',
  email: 'Email us',
  phone: 'Call us',
  whatsapp:"Chat on WhatsApp",
  phoneRequired: 'Please enter your phone number',
  fileTypeInvalid: 'Only PDF, PNG and JPG files are allowed.',
  fileTooLarge: 'File size must not exceed 30 MB.',
  allowedFiles: 'Allowed formats: PDF, PNG, JPG',
  seoDescription: 'Noova designs and builds software products, web platforms and mobile apps for growing businesses.',
  fileRequired: 'Please attach your resume',
  phoneInvalid: 'Enter a valid phone number using digits only',
  emailRequired: 'Please enter your email address',
  emailInvalid: 'Enter a valid email address, like name@example.com',
  nameRequired: 'Please enter your first name',
  lastNameRequired: 'Please enter your last name',
  SuccessMessage: 'Thank you! We have received your details and will be in touch soon.',
  errorMessage: 'Something went wrong. Please check your details and try again.',
  errorServerMessage: 'Our server is having trouble right now. Please try again in a few minutes.',
  Loading: 'Loading…',
  DownloadResome: 'Download our portfolio',
  visitWebsite: 'Visit website',
    download:'Download',
   
  androidVersion: "Android Version",
  iosVersion: "iOS Version",
  networkError: 'No connection. Check your internet and try again.',
  sending: 'Sending…',
  textRequired: 'Please enter your message',
  textInvalid: 'Your message contains invalid characters',
  remote: 'Remote',
  view: 'View',
  noItems: 'Nothing to show here yet. Please check back soon.',
  backToJobs: 'All job openings',
  aboutRole: 'About the role',
  applyNow: 'Apply for this role',
  applyHint: 'Send us your details and CV. We reply to every application.',
  seoProducts: 'Software products and platforms built by Noova: web apps, mobile apps and desktop software for growing businesses.',
  seoProjects: 'Selected projects delivered by Noova: websites, mobile apps and custom software built for real businesses.',
  seoBlog: 'Articles from the Noova team on web development, mobile apps, UI/UX design, SEO, AI and security.',
  seoAbout: 'Learn about Noova, our mission, vision and the team building software products for businesses.',
  seoContact: 'Contact Noova to discuss your website, mobile app or custom software project.',
  seoJobs: 'Open positions at Noova. Join a remote team building software products.',
  seoCertification: 'Certificates and awards earned by Noova.',
  seoFeedback: 'What our customers say about working with Noova.',
};
